import { Component, OnInit } from '@angular/core';
import { SignalRService } from '@services/signalr/signal-rservice.service';
import { ApiService } from '@services/api/api.service';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { Router } from '@angular/router';
import { NotificationsService } from '@services/notifications/notifications.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {

  loading: boolean = false;
  constructor(private signalRService: SignalRService,
    private apiService: ApiService,
    private auth: IdentityAuthService,
    private router: Router,
    public notificationsService: NotificationsService) { }

  ngOnInit() {
    this.loading = true;
  }

  public viewItem(noti) {
    this.router.navigateByUrl((noti.isSecondaryUrl ? 'secondaryUrl' : '') + noti.url);
  }

public clearAll(){

this.apiService.post(`/api/Notification/clearAll`, {})
      .subscribe(res => {
        this.notificationsService.notifications.splice(0, this.notificationsService.notifications.length);
      }, err => {

      })
}

  public closeItem(noti, e) {
    e.stopPropagation();
    this.apiService.post(`/api/Notification/updateStatus/${noti.id}/2`, {})
      .subscribe(res => {
        this.notificationsService.notifications.splice(this.notificationsService.notifications.indexOf(noti), 1);
      }, err => {

      })

  }
  closeItems(e) {
    e.stopPropagation();
    this.notificationsService.notifications.forEach(noti => {
      this.apiService.post(`/api/Notification/updateStatus/${noti.id}/2`, {})
        .subscribe(res => {
          this.notificationsService.notifications.splice(this.notificationsService.notifications.indexOf(noti), 1);
        }, err => {

        })
    })
  }
}
